import React from 'react'
import Coursecontent from '../components/courseContent/Coursecontent'
import Navbar from '../components/Navbar/Navbar'


const CourseContentPage = () => {
  return (
    <>
   
    <Navbar/>
    <Coursecontent/>
    </>
  )
}

export default CourseContentPage